export const SnapshotStatus = {
  Pending: 'pending',
  Success: 'success',
  Error: 'error',
} as const;

export type SnapshotStatus = (typeof SnapshotStatus)[keyof typeof SnapshotStatus];

export type SnapshotItem<TBefore, TAfter = TBefore> = {
  id: string;
  before: Partial<TBefore>;
  after?: Partial<TAfter>;
} & (
  | {
      status: typeof SnapshotStatus.Error;
      error?: string;
    }
  | {
      status: Exclude<SnapshotStatus, typeof SnapshotStatus.Error>;
      error?: never;
    }
);

export type SnapshotResult = {
  success?: boolean;
  error?: string;
};

/** The (unwrapped) store instance returned by a `createSnapshotStore` hook. */
export type SnapshotStore<T extends SnapshotItem<unknown, unknown>> = {
  items: T[];
  finishedCount: number;
  hasErrors: boolean;
  isFinished: boolean;
  getItemById: (id: string) => T | undefined;
  upsertItems: (newItems: T[]) => void;
  updateItem: (updatedItem: T) => void;
  updateItemAfterProp: (id: string, after: T['after']) => void;
  finishItem: (result: SnapshotResult & {id: string; after?: T['after']}) => T | undefined;
  reset: () => void;
};
